import type { Folder } from '../../../../util/Types/Folder';

export const mergeLocalFolderState = (prev: Folder, next: Folder): Folder => {
  if (prev === next) return prev;
  if (
    prev.id === next.id &&
    prev.name === next.name &&
    prev.rank === next.rank &&
    prev.parentId === next.parentId &&
    prev.section === next.section &&
    prev.space === next.space &&
    prev.folders === next.folders &&
    prev.flows === next.flows &&
    prev.objects === next.objects &&
    prev.namespaces === next.namespaces
  ) {
    return prev;
  }
  return {
    ...prev,
    ...next,
    folders: next.folders ?? prev.folders,
  };
};
